import React, { useState, useEffect } from "react";
import { Base64 } from "js-base64";
import Lightbox from "react-image-lightbox";
import "./AdminPackage.css";
import  ListingSkeleton  from './ListingSkeleton';
import  DetailsSkeleton  from './DetailsSkeleton';
import { getHotellistInAdminPackageList } from "../../Component/axios";
import { LazyLoadImage } from 'react-lazy-load-image-component';
//import { Link } from "react-scroll";

import AboutDetails from './AccomodationDetails/AboutDetails'
import RatesDetails from './AccomodationDetails/RatesDetails'
import GoogleMap from "./AccomodationDetails/GoogleMap";
import {
  HotelListDataById, SupplierUrl
} from "../../Component/axios";
const SortArr = [
  { id: "4", name: "Recommended" },
  { id: "1", name: "Price - Low to High" },
  { id: "2", name: "Price - High to Low" },
  { id: "3", name: "User Rating - High to Low" },
];

function AccomodationListingPopup(props) {
  const accommodationArr = props?.accommodation;
 const AccommodationsData= JSON.parse(props?.accommodation);
  const [openAccomodationDetails, setopenAccomodationDetails] = useState('ACCL');

  const [hotelList, sethotelList] = useState(null);
  const [hotelListFilter, sethotelListFilter] = useState(null);
  // const [guestCombination, setguestCombination] = useState("");
  // const [tourGalleryDetails, settourGalleryDetails] = useState([]);
  const [cats, setcats] = useState([{ adultCounter: 1, childCounter: 0, roomCounter: 1, isExpanded: true },]);
  const [sortingSelect, setsortingSelect] = useState("Recommended");
  const [sorting, setsorting] = useState(false);
  const [sortingId, setsortingId] = useState(null);
  const [ImageChanger, setImageChanger] = useState();
  const [HotelDetails, setHotelDetails] = useState("");
  const [HotelGallery, setHotelGallery] = useState("");
  const [HotelServices, setHotelServices] = useState([]);
  const [Neighbourhoodareas, setNeighbourhoodareas] = useState([]);
  const [EJuniper, setEJuniper] = useState([]);
  const [HSPortal, setHSPortal] = useState([]);
  const [HotelLink, setHotelLink] = useState([]);
  const [defaultZoneval, setdefaultZoneval] = useState("Seychelles");
  const [roomDescription, setroomDescription] = useState({});
  const [JuniperDesc, setJuniperDesc] = useState([]);
  const [photoIndex, setphotoIndex] = useState(0);
  const [isOpenGallery, setisOpenGallery] = useState(false);
  const [error,  setError] = useState(null);
  const [CartIndexNumber,  setCartIndexNumber] = useState(null);

  useEffect(() => {

    const JSONObject = JSON.parse(accommodationArr);
setCartIndexNumber(JSONObject.IndexNumber);

getHotellistInAdminPackageList(accommodationArr).then(
    (data) => {
 
      if (data == undefined) {
        sethotelList(null);
      } else {
        if (data == "nohotel") {
          sethotelList(data);
        } else {
          sethotelList(data);
          sethotelListFilter(data);
        }
      }
    }
  );
  }, []);
  let backListingPage = () => {
    setopenAccomodationDetails('ACCL');
 
  };
  
  let detailsPageData = (hotelId) => {
    setopenAccomodationDetails('ACCD');
    setHotelDetails("");
    const query =  accommodationArr;
    const HotelId =   Base64.btoa(hotelId);
   
    HotelListDataById(HotelId, query).then(
      (result) => {
        result.map((item, key) => {
      
          setHotelDetails(item?.details);
          setdefaultZoneval(item?.details.property_name);
          setHotelGallery(item?.property_gallery);
          setHotelServices(item?.property_services_facilities);
          setNeighbourhoodareas(item?.neighbourhoodareas);
          if (item.ejuniper != null) {
            setEJuniper(item?.ejuniper);
          }
          if (item.hs_portal != null) {
           setHSPortal(item?.hs_portal);
          }
          if (item.hotel_link != null) {
          setHotelLink(item?.hotel_link);
          }
          setJuniperDesc(item?.property_description);
          setroomDescription(item?.rooms_description);
        });
      },
      (error) => {
      
          setError(error);
       
      }
    );
  };

  let openAccomodationFacilityGalary = () =>{
    
    setopenAccomodationDetails('ACCF');
  }
  let backAccomodationDetails = () =>{
    setopenAccomodationDetails('ACCD');
  }

  const showSorting = (syntheticEvent) => {
    
    syntheticEvent.stopPropagation();
    setsorting(true);
  };
  const handleSortingChange = (e) => {

    sethotelList(null);

    const sorArr = hotelList;
    if (e?.id == 2) {
      setTimeout(() => {
        const getValue = (price) => -price;
        sorArr.sort(
          (a, b) =>
            getValue(
              a?.details?.property_source == 1
                ? a.ejuniper?.NewAmount == "0.00"
                  ? a.ejuniper?.HotelOfferAmount
                  : a.ejuniper?.NewAmount
                : a?.details?.property_source == 2
                ? a?.hotellink?.amount
                : a?.hs_portal?.amount
            ) -
            getValue(
              b?.details?.property_source == 1
                ? b?.ejuniper?.NewAmount == "0.00"
                  ? b?.ejuniper?.HotelOfferAmount
                  : b?.ejuniper?.NewAmount
                : b?.details?.property_source == 2
                ? b?.hotellink?.amount
                : b?.hs_portal?.amount
            )
        );

        sethotelList(sorArr);
      }, 2000);
    } else if (e?.id == 3) {
      setTimeout(() => {
        const getValue = (star) => -star;
        sorArr.sort(
          (a, b) =>
            getValue(
              a?.details?.star_category_id > 5 ? "0" : a?.details?.star_category_id
            ) -
            getValue(
              b?.details?.star_category_id > 5 ? "0" : b?.details?.star_category_id
            )
        );

        sethotelList(sorArr);
      }, 2000);
    } else if (e?.id == 1) {
      setTimeout(() => {
        if (sorArr[0].matched) {
          const sliceArr = sorArr.shift();
          const getValue = (price) => +price;
          sorArr.sort(
            (a, b) =>
              getValue(
                a?.details?.property_source == 1
                  ? a?.ejuniper?.NewAmount == "0.00"
                    ? a?.ejuniper?.HotelOfferAmount
                    : a?.ejuniper?.NewAmount
                  : a?.details?.property_source == 2
                  ? a?.hotellink?.amount
                  : a?.hs_portal?.amount
              ) -
              getValue(
                b?.details?.property_source == 1
                  ? b?.ejuniper?.NewAmount == "0.00"
                    ? b?.ejuniper?.HotelOfferAmount
                    : b?.ejuniper?.NewAmount
                  : b?.details?.property_source == 2
                  ? b?.hotellink?.amount
                  : b?.hs_portal?.amount
              )
          );
         // const newArr = sorArr.splice(0, 0, sliceArr);
          sethotelList(sorArr);
        } else {
          const getValue = (price) => +price;
          sorArr.sort(
            (a, b) =>
              getValue(
                a?.details?.property_source == 1
                  ? a?.ejuniper?.NewAmount == "0.00"
                    ? a?.ejuniper?.HotelOfferAmount
                    : a?.ejuniper?.NewAmount
                  : a?.details?.property_source == 2
                  ? a?.hotellink?.amount
                  : a?.hs_portal?.amount
              ) -
              getValue(
                b?.details?.property_source == 1
                  ? b?.ejuniper?.NewAmount == "0.00"
                    ? b?.ejuniper?.HotelOfferAmount
                    : b?.ejuniper?.NewAmount
                  : b?.details?.property_source == 2
                  ? b?.hotellink?.amount
                  : b?.hs_portal?.amount
              )
          );
          sethotelList(sorArr);
        }
      }, 2000);
    }else if(e.id == 4){
    
      setTimeout(() => {
      const getValue = (id) => id;
      sorArr.sort(
        (a, b) =>
          getValue(
            a.details.id
          ) -
          getValue(
            b.details.id
          )
      );
      sethotelList(sorArr);
          }, 2000)
    }

    setsortingSelect(e.name);
     setsortingId(e.id);
     setsorting(false);
  };

  const onMouseOutFun = (image) => {
    setImageChanger(image);
  };
  const onMouseOverFun = (image) => {
    setImageChanger(image);
  };
  const getAmountHotelLink = (data) => {
    const data12 = Object.entries(data?.forMeal);
    const rateId = data12.filter(([key, value]) => value == data?.amount);

    

    const Offer1 = data.specialOffer.filter(
      (item, key) =>
        item != "no_offer" && item?.roomSpecial?.rate_plan_id == rateId[0][0]
    );

    if (Offer1.length > 0) {
      let result = [];

      Offer1.map((i, j) => {
        
        if (i.combineoffer == "nocombine") {
          if (i.specialdata.spl_offer_type_id == 1) {
            const dis =
              data?.amount * parseInt(i?.specialdata?.pay_stay_length) -
              data?.amount * parseInt(i?.specialdata?.pay_stay_value);
             
            const disA =
              (dis / (data?.amount * parseInt(i?.specialdata?.pay_stay_length))) *
              100;
           
            result.push(disA);
          } else {
            if (i?.specialdata?.discount_in == 2) {
              const disA = i?.specialdata?.rate_discount;
              result.push(+disA);
            } else {
              const disA = data?.amount - i?.specialdata?.rate_discount;
              result.push(+disA);
            }
          }
        } else {
          if (i?.specialdata?.spl_offer_type_id == 1) {
            const dis =
              data?.amount * parseInt(i?.specialdata?.pay_stay_length) -
              data?.amount * parseInt(i?.specialdata?.pay_stay_value);
            const disA =
              (dis / (data?.amount * parseInt(i?.specialdata?.pay_stay_length))) *
              100;
            result.push(disA);
          } else {
            if (i?.specialdata?.discount_in == 2) {
              const disA = i?.specialdata?.rate_discount;
              result.push(+disA);
            } else {
              const disA = data?.amount - i?.specialdata?.rate_discount;
              result.push(+disA);
            }
          }
        }
      });

      const Amount = result.reduce((a, v) => a + v, 0);

      const balanceAmount =
        data.amount - (Math.round(Amount * data.amount) / 100).toFixed(2);

      return (
        <>
          {/* <p><span className="font-weight-bold text-lowercase from-price-text"> </span></p> */}
          <div className="listingPrice">
          <p
            className="grayText font16 lineThrough appendBottom5 appendRight5"
            id="hlistpg_hotel_cut_price"
          >
           <span>€</span>{(data.amount).toFixed(2)}
          </p>
          <p
            className="latoBlack font16 blackText appendBottom5"
            id="hlistpg_hotel_shown_price"
          >
            <span>€</span>{balanceAmount.toFixed(2)}
          </p>
          </div>
          <p class="makeFlex hrtlCenter right appendBottom10 directionRtl">
            <span class="redText font12">
              <span>Save </span>
              <span class="latoBold" id="hlistpg_hotel_saved_price">
              <span>€</span>{(Math.round(Amount * data.amount) / 100).toFixed(2)}
              </span>
            </span>
            <span class="spriteNew discountIcon relative appendLeft5">
              <span
                class="latoBold font11 whiteText discountText"
                id="hlistpg_hotel_saved_price_percentage"
                style={{
                  lineHeight: "15px",
                  paddingRight: "5px",
                }}
              >
                {parseInt(Amount)}%
              </span>
            </span>
          </p>
        </>
      );
    } else {
      return (
        <>
        {/* <p><span className="font-weight-bold text-lowercase from-price-text"> </span></p> */}
        <p
          className="latoBlack font16 blackText appendBottom5"
          id="hlistpg_hotel_shown_price"
        >
          <span>€</span>{(data.amount).toFixed(2)}
        </p>
        </>
      );
    }
  };

  const getAmountHsPortal = (data) => {
  //console.log(data);
    const data12 = Object.entries(data?.forMeal);
    const rateId = data12.filter(([key, value]) => value == data?.amount);

    const Offer1 = data.specialOffer.filter(
      (item, key) =>
        item != "no_offer" && item.roomSpecial.rate_plan_id == rateId[0][0]
    );

    if (Offer1.length > 0) {
      let result = [];

      Offer1.map((i, j) => {
     
        if (i.combineoffer == "nocombine") {
          if (i.specialdata.spl_offer_type_id == 1) {
            const dis =
              data.amount * parseInt(i.specialdata.pay_stay_length) -
              data.amount * parseInt(i.specialdata.pay_stay_value);
         
            const disA =
              (dis / (data.amount * parseInt(i.specialdata.pay_stay_length))) *
              100;
          
            result.push(disA);
          } else {
            if (i.specialdata.discount_in == 2) {
              const disA = i.specialdata.rate_discount;
              result.push(+disA);
            } else {
              const disA = data.amount - i.specialdata.rate_discount;
              result.push(+disA);
            }
          }
        } else {
          if (i.specialdata.spl_offer_type_id == 1) {
            const dis =
              data.amount * parseInt(i.specialdata.pay_stay_length) -
              data.amount * parseInt(i.specialdata.pay_stay_value);
            const disA =
              (dis / (data.amount * parseInt(i.specialdata.pay_stay_length))) *
              100;
            result.push(disA);
          } else {
            if (i.specialdata.discount_in == 2) {
              const disA = i.specialdata.rate_discount;
              result.push(+disA);
            } else {
              const disA = data.amount - i.specialdata.rate_discount;
              result.push(+disA);
            }
          }
        }
      });

      const Amount = result.reduce((a, v) => a + v, 0);

      const balanceAmount =
        data.amount - (Math.round(Amount * data.amount) / 100).toFixed(2);

      return (
        <>
          {/* <p><span className="font-weight-bold text-lowercase from-price-text"> </span></p> */}
          <div className="listingPrice">
          <p
            className="grayText font16 lineThrough appendBottom5 appendRight5"
            id="hlistpg_hotel_cut_price"
          >
           <span>€</span>{(data.amount).toFixed(2)}
          </p>
          <p
            className="latoBlack font16 blackText appendBottom5"
            id="hlistpg_hotel_shown_price"
          >
           <span>€</span>{balanceAmount.toFixed(2)}
          </p>
          </div>
          <p class="makeFlex hrtlCenter right appendBottom10 directionRtl">
            <span class="redText font12">
              <span>Save </span>
              <span class="latoBold" id="hlistpg_hotel_saved_price">
              <span>€</span>{(Math.round(Amount * data.amount) / 100).toFixed(2)}
              </span>
            </span>
            <span class="spriteNew discountIcon relative appendLeft5">
              <span
                class="latoBold font11 whiteText discountText"
                id="hlistpg_hotel_saved_price_percentage"
                style={{
                  lineHeight: "15px",
                  paddingRight: "5px",
                }}
              >
                {parseInt(Amount)}%
              </span>
            </span>
          </p>
        </>
      );
    } else {
      return (
        <>
        {/* <p><span className="font-weight-bold text-lowercase from-price-text"> </span></p> */}
        <p
          className="latoBlack font16 blackText appendBottom5"
          id="hlistpg_hotel_shown_price"
        >
         <span>€</span>{(data.amount).toFixed(2)}
        </p>
        </>
      );
    }
  };
// ================Details Page===========

const setImagePhotoIndex = (index) => {
  setisOpenGallery(true);
  setphotoIndex(index);
};
const handleSetActive = (to) => {
    
};
const handleSetInactive = (to) => {
 
};

  return (
    <div className="slider-container">
      <div className="modalContent">
        <div>
          <div className="theme-wrapper">
            {openAccomodationDetails == 'ACCD' ? (
              <>
               {HotelDetails == "" ? (
                    <>
                       <DetailsSkeleton/>
                    </>
                  ):(<> 
                <div className="sidePanelWrap viewDetails_panelV2">
                  <div className="sidePanelTopSection">
                    <div className="makeFlex spaceBetween hrtlCenter appendBottom20 ">
                      <div className="viewDetailsHeading cursorPointer">
                        <span
                          id="hotelBackArrow"
                          className="overlaySprite backArrowBlue backIcon appendTop3"
                          onClick={() => backListingPage() } ></span>
                        <span className="font20 blackText latoBlack viewDetailText" >
                          Back to hotel listing
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="htDetails" id="hotelDetailTop">
                    <div className="makeFlex hrtlCenter">
                      <h3 className="font18 latoBlack appendBottom2 lineHeight22 false">
                      {HotelDetails.property_name}
                      </h3>
                      <div className="starRatng">
                        <span className="hotelRating rating_blank">
                          <span
                            className="hotelRating rating_fill "
                            style={{ width: "36px" }}
                          ></span>
                        </span>
                      </div>
                      {/* <div className="imgWrap0">
                        <span className="overlaySprite selectedHotelRedBadge"></span>
                      </div> */}
                    </div>
                    <p className="latoBold font11 greyText lineHeight14">
                    {HotelDetails.address_line_1}
                    </p>
                    <div className="latoBold font11 greyText lineHeight14 appendBottom15"></div>
                    {/* <div className="makeFlex appendBottom10">
                      <div className="imgWrap1"></div>0
                      <div className="ratingContainer marginLeft22">
                        <div className="ratingBadgeContainer  goodRating">
                          <p className="selectedBadgeText font12">
                            4.4<span className="font10">/5</span>
                          </p>
                        </div>
                      </div>
                      <div className="readAllReviews">Read 231 Reviews</div>
                    </div> */}
                    <div className="makeFlex appendBottom10 grid-five">
                      <div className="imgWrap1"  onClick={() => openAccomodationFacilityGalary() }>
                       
                        <div className="GalleryHeader">
                          <div className="GalleryImg">
                            <div className="GalleryBig_img">
                              <LazyLoadImage
                                src={HotelGallery[0]}
                                className="Gallery_images_Large"
                                style={{
                                  borderTopLeftRadius: 15,
                                  borderBottomLeftRadius: 15,
                                  height: "350px",
                                }}
                                onClick={() => setImagePhotoIndex(0)}
                                placeholderSrc={
                                  process.env.PUBLIC_URL + "images/placeholder.png"
                                }
                                key={0}
                              />
                            </div>
                            <div className="GallerySmall_img">
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  className="GallerySmallerSection"
                                  style={{ paddingRight: 5, paddingBottom: 5 }}
                                >
                                  {HotelGallery.length < 1 ? (
                                    <img
                                      src="images/placeholder.png"
                                      className="Gallery_images_Small"
                                      onClick={() => setImagePhotoIndex(1)}
                                      key={1}
                                      
                                    />
                                  ) : (
                                    <LazyLoadImage
                                      src={HotelGallery[1]}
                                      className="Gallery_images_Small"
                                      onClick={() => setImagePhotoIndex(1)}
                                      placeholderSrc={
                                        process.env.PUBLIC_URL + "images/placeholder.png"
                                      }
                                      key={1}
                                    />
                                  )}
                                </div>
                                <div
                                  className="GallerySmallerSection"
                                  style={{ paddingRight: 5, paddingTop: 5 }}
                                >
                                  {HotelGallery.length < 2 ? (
                                    <img
                                      src="images/placeholder.png"
                                      className="Gallery_images_Small"
                                      onClick={() => setImagePhotoIndex(2)}
                                      key={2}
                                    />
                                  ) : (
                                    <LazyLoadImage
                                      src={HotelGallery[2]}
                                      className="Gallery_images_Small"
                                      onClick={() => setImagePhotoIndex(2)}
                                      placeholderSrc={
                                        process.env.PUBLIC_URL + "images/placeholder.png"
                                      }
                                      key={2}
                                    />
                                  )}
                                </div>
                              </div>

                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  className="GallerySmallerSection"
                                  style={{ paddingLeft: 5, paddingBottom: 5 }}
                                >
                                  {HotelGallery.length < 3 ? (
                                    <img
                                      src="images/placeholder.png"
                                      className="Gallery_images_Small"
                                      onClick={() => setImagePhotoIndex(3)}
                                      key={3}
                                    />
                                  ) : (
                                    <LazyLoadImage
                                      src={HotelGallery[3]}
                                      className="Gallery_images_Small"
                                      onClick={() => setImagePhotoIndex(3)}
                                      placeholderSrc={
                                        process.env.PUBLIC_URL + "images/placeholder.png"
                                      }
                                      key={3}
                                    />
                                  )}
                                </div>
                                <div
                                  className="GallerySmallerSection"
                                  style={{ paddingLeft: 5, paddingTop: 5 }}
                                >
                                  {HotelGallery.length < 4 ? (
                                    <img
                                      src="images/placeholder.png"
                                      className="Gallery_images_Small"
                                      onClick={() => setImagePhotoIndex(4)}
                                      key={4}
                                    />
                                  ) : (
                                    <LazyLoadImage
                                      src={HotelGallery[4]}
                                      className="Gallery_images_Small"
                                      onClick={() => setImagePhotoIndex(4)}
                                      placeholderSrc={
                                        process.env.PUBLIC_URL + "images/placeholder.png"
                                      }
                                      key={4}
                                    />
                                  )}
                        {/* <div className="Image_showAll_btn">
                          <p className="Image_showAll_content">
                            {" "}
                            Show all photos ({images.length}){" "}
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {isOpenGallery && (
                <Lightbox
                  mainSrc={HotelGallery[photoIndex]}
                  nextSrc={HotelGallery[(photoIndex + 1) % HotelGallery?.length]}
                  prevSrc={
                    HotelGallery[
                      (this.state.photoIndex + HotelGallery?.length - 1) %
                        HotelGallery.length
                    ]
                  }
                  onCloseRequest={() => setisOpenGallery(false)}
                  onMovePrevRequest={() =>
                   
                      setphotoIndex(
                        (photoIndex + HotelGallery.length - 1) %
                        HotelGallery.length,)
                  }
                  onMoveNextRequest={() =>
                      setphotoIndex((photoIndex + 1) % HotelGallery.length,)
                  }
                  wrapperClassName="ImageModal"
                />
              )}
                      </div>
                      {/* <div className="appendRight2">
                        <div className="imgWrap3">
                          <div className="splitImageWrap">
                            <div className="imageLoaderContainer ">
                              <img
                                className=" active "
                                src="https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/201904031849475047-82291ccc549411ea893a0242ac110005.jpg?&amp;downsize=900:675&amp;crop=900:675;56,0&amp;output-format=jpg"
                                style={{ borderRadius: "4px" }}
                              />
                            </div>
                          </div>
                          <div className="splitImageWrap">
                            <div className="imageLoaderContainer ">
                              <img
                                className=" active "
                                src="https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/201904031849475047-4c5a2336549711eaa1670242ac110005.jpg?&amp;downsize=900:675&amp;crop=900:675;56,0&amp;output-format=jpg"
                                style={{ borderRadius: "4px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="imgWrap5">
                        <div className="splitImageWrap">
                          <div className="imageLoaderContainer ">
                            <img
                              className=" active "
                              src="https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/201904031849475047-c9bd3082549411ea82180242ac110007.jpg?&amp;downsize=900:675&amp;crop=900:675;56,0&amp;output-format=jpg"
                              style={{ borderRadius: "4px" }}
                            />
                          </div>
                        </div>
                        <div className="splitImageWrap">
                          <div className="imageLoaderContainer ">
                            <img
                              className=" active "
                              src="https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/201904031849475047-1f5f2d54549711eaa1670242ac110005.jpg?&amp;downsize=900:675&amp;crop=900:675;56,0&amp;output-format=jpg"
                              style={{ borderRadius: "4px" }}
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  {/* <div className="_navSticky navSticky appendBottom15">
                  <ul id="hotel_trip_tab" className=" hotel tripTab" style={{marginTop: '43%'}}>
                    <li id="About_the_hotel_0" className="">
                      About the hotel
                    </li>
                    <li id="Rooms_1" className="">
                      Rooms
                    </li>
                    <li id="Facilities_2" className="">
                      Facilities
                    </li>
                    <li id="Location_3" className="">
                      Location
                    </li>
                    <li>
                  <Link
                    activeClass="active"
                    to="About_the_hotel_0"
                    spy={true}
                    smooth={true}
                    duration={100}
                    offset={0}
                    onSetActive={handleSetActive}
                    onSetInactive={handleSetInactive}
                    ignoreCancelEvents={false}
                  >
                    About the hotel
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    to="Rooms"
                    spy={true}
                    smooth={true}
                    duration={100}
                    offset={0}
                    onSetActive={handleSetActive}
                    onSetInactive={handleSetInactive}
                    ignoreCancelEvents={false}
                  >
                   Rooms Options
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    to="Facilities_2"
                    spy={true}
                    smooth={true}
                    duration={100}
                    offset={0}
                    onSetActive={handleSetActive}
                    onSetInactive={handleSetInactive}
                    ignoreCancelEvents={false}
                  >
                    Amenities
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    to="Location_3"
                    spy={true}
                    smooth={true}
                    duration={100}
                    offset={0}
                    onSetActive={handleSetActive}
                    onSetInactive={handleSetInactive}
                    ignoreCancelEvents={false}
                  >
                    Location
                  </Link>
                </li>
                    <li id="Rating_and_Review_4" className="">
                      Rating and Review
                    </li>
                  </ul>
                  </div> */}
                  <div className="scrollMargin130" id="About_the_hotel" style={{marginTop: '43%'}}>
                    <AboutDetails detailsAbout={HotelDetails} JuniperDesc={JuniperDesc}  neighbourhoodareas={Neighbourhoodareas}/>
                  </div>
                 
                  <div
                    className="viewDetailsWrapper scrollMargin130"
                    id="Rooms"
                  >
                    {HotelDetails?.property_source == 1 ? (
                  <>
                    {" "}
                    {EJuniper.length >0 ? (
                      <>
                        {" "}
                        {EJuniper.map((item, key) => (
                          <RatesDetails
                            propertyName={HotelDetails?.property_name}
                            eJuniper={item}
                            hs_portal="no_hs_portal"
                            hotel_link="no_hotel_link"
                            HotelDetails={HotelDetails}
                            querySearching={accommodationArr}
                            HotelImage={HotelGallery[0]}
                            roomDescription={roomDescription}
                            CartIndexNumber = {CartIndexNumber}
                            propertyCheckin = {HotelDetails?.check_in.split(":")[0] < 12
                            ? HotelDetails?.check_in + " AM"
                            : HotelDetails?.check_in.split(":")[0] -
                                12 ==
                              0
                            ? "12" +
                              ":" +
                              HotelDetails?.check_in.split(":")[1] +
                              " PM"
                            : HotelDetails?.check_in.split(":")[0] +
                              ":" +
                              HotelDetails?.check_in.split(":")[1] +
                              " PM"}
                              propertyCheckout = {HotelDetails?.check_out.split(":")[0] < 12
                              ? HotelDetails?.check_out + " AM"
                              : HotelDetails?.check_out.split(":")[0] -
                                  12 ==
                                0
                              ? "12" +
                                ":" +
                                HotelDetails?.check_out.split(":")[1] +
                                " PM"
                              : HotelDetails?.check_out.split(":")[0] +
                                ":" +
                                HotelDetails?.check_out.split(":")[1] +
                                " PM"}
                                description = {JuniperDesc[0]}
                           

                          ></RatesDetails>
                        ))}
                      </>
                    ) : (
                      <> </>
                    )}
                  </>
                ) : (
                  <>
                    {" "}
                    {HotelDetails?.property_source == 2 ? (
                      <>
                        {" "}
                        {HotelLink.length >0 ? (
                          <>
                            {" "}
                            {Object.keys(HotelLink).map((key) => (
                              <RatesDetails
                                propertyName={
                                  HotelDetails.property_name
                                }
                                eJuniper="no_ejuniper"
                                hs_portal="no_hs_portal"
                                hotel_link={HotelLink[key]}
                                HotelDetails={HotelDetails}
                                querySearching={accommodationArr}
                                HotelImage={HotelGallery[0]}
                                roomDescription="no_descr"
                                CartIndexNumber = {CartIndexNumber}
                                propertyCheckin = {HotelDetails.check_in.split(":")[0] < 12
                                ? HotelDetails?.check_in + " AM"
                                : HotelDetails?.check_in.split(":")[0] -
                                    12 ==
                                  0
                                ? "12" +
                                  ":" +
                                  HotelDetails?.check_in.split(":")[1] +
                                  " PM"
                                : HotelDetails?.check_in.split(":")[0] +
                                  ":" +
                                  HotelDetails?.check_in.split(":")[1] +
                                  " PM"}
                                  propertyCheckout = {HotelDetails?.check_out.split(":")[0] < 12
                                  ? HotelDetails?.check_out + " AM"
                                  : HotelDetails?.check_out.split(":")[0] -
                                      12 ==
                                    0
                                  ? "12" +
                                    ":" +
                                    HotelDetails?.check_out.split(":")[1] +
                                    " PM"
                                  : HotelDetails?.check_out.split(":")[0] +
                                    ":" +
                                    HotelDetails?.check_out.split(":")[1] +
                                    " PM"}
                                    description = {HotelDetails?.property_description}
                               
                              ></RatesDetails>
                            ))}
                          </>
                        ) : (
                          <> </>
                        )}
                      </>
                    ) : (
                      <>
                        {" "}
                        {HSPortal.length >0 ? (
                          <>
                            {" "}
                            {Object.keys(HSPortal).map((key) => (
                              <RatesDetails
                                propertyName={
                                  HotelDetails?.property_name
                                }
                                eJuniper="no_ejuniper"
                                hotel_link="no_hotel_link"
                                hs_portal={HSPortal[key]}
                                HotelDetails={HotelDetails}
                                querySearching={accommodationArr}
                                HotelImage={HotelGallery[0]}
                                roomDescription="no_descr"
                                CartIndexNumber = {CartIndexNumber}
                                propertyCheckin = {HotelDetails?.check_in.split(":")[0] < 12
                                ? HotelDetails?.check_in + " AM"
                                : HotelDetails?.check_in.split(":")[0] -
                                    12 ==
                                  0
                                ? "12" +
                                  ":" +
                                  HotelDetails?.check_in.split(":")[1] +
                                  " PM"
                                : HotelDetails?.check_in.split(":")[0] +
                                  ":" +
                                  HotelDetails?.check_in.split(":")[1] +
                                  " PM"}
                                  propertyCheckout = {HotelDetails?.check_out.split(":")[0] < 12
                                  ? HotelDetails?.check_out + " AM"
                                  : HotelDetails?.check_out.split(":")[0] -
                                      12 ==
                                    0
                                  ? "12" +
                                    ":" +
                                    HotelDetails?.check_out.split(":")[1] +
                                    " PM"
                                  : HotelDetails?.check_out.split(":")[0] +
                                    ":" +
                                    HotelDetails?.check_out.split(":")[1] +
                                    " PM"}
                                    description = {HotelDetails?.property_description}
                           
                              ></RatesDetails>
                            ))}{" "}
                          </>
                        ) : (
                          <> </>
                        )}
                      </>
                    )}
                  </>
                )}
                    <div
                      className="appendBottom15 scrollMargin130"
                      id="Facilities"
                    >
                      <div className="facilities">
                        <h3 className="latoBlack font16 appendBottom10">
                          Facilities
                        </h3>
                        <div className="facilityList">
                          {/* <ul id="propertyFacilityList">
                            <li>
                              <span className="amenitiesSpriteOverlay icon24 amenityIconDefault"></span>
                              Top Facilities
                            </li>
                            <li>
                              <span className="amenitiesSpriteOverlay icon24 amenityIconDefault"></span>
                              Activities
                            </li>
                            <li>
                              <span className="amenitiesSpriteOverlay icon24 amenityIconDefault"></span>
                              Food And Drink
                            </li>
                            <li>
                              <span className="amenitiesSpriteOverlay icon24 amenityIcon63"></span>
                              Other
                            </li>
                          </ul> */}
                          <p
                            //id="openGalleryBtn"
                            className="pushRight font12 latoBold capText makeRelative linkText cursorPointer wdth88"
                            onClick={() => openAccomodationFacilityGalary() }
                          >
                            All Facilities and Gallery Click 
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="appendBottom20 scrollMargin130"
                      id="Location"
                    >
                      <div className="locSide">
                        <h3 className="latoBlack font16 appendBottom10">
                          Location
                        </h3>
                        <div>
                          <p> {HotelDetails.address_line_1}</p>
                          <div className="imgWrap">
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                              }}
                            >
                              <GoogleMap
                                      lat={HotelDetails.latitude}
                                      lng={HotelDetails.longitude}
                                      src={HotelGallery[0]}
                                      ProDetails={HotelDetails}
                                  />
                              {/* <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  left: "0px",
                                  top: "0px",
                                  margin: "0px",
                                  padding: "0px",
                                  position: "absolute",
                                }}
                              >
                                <div style={{ height: "100%", width: "100%" }}>
                                  <div style={{ overflow: "hidden" }}></div>
                                  
                                </div>
                              </div> */}
                              {/* <div
                                style={{
                                  width: "50%",
                                  height: "50%",
                                  left: "50%",
                                  top: "50%",
                                  margin: "0px",
                                  padding: "0px",
                                  position: "absolute",
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    left: "0px",
                                    top: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    position: "absolute",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "0px",
                                      height: "0px",
                                      left: "0px",
                                      top: "0px",
                                      backgroundColor: "transparent",
                                      position: "absolute",
                                    }}
                                  >
                                   
                                    <span className="holidaySprite mmtMapIcon"></span>
                                  </div>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div
                      className="appendBottom10 scrollMargin130"
                      id="Rating_and_Review"
                    >
                      <div className="guestRvHd paddingContainer">
                        <h3 className="latoBlack font16 appendBottom20">
                          Guest Rating &amp; Review
                        </h3>
                        <div className="rvBdy">
                          <div className="makeFlex hrtlCenter goodRating">
                            <p className="latoBlack font36 appendRight10 lineHeight44">
                              4.4
                            </p>
                            <p className="font11 lineHeight16 makeFlex column">
                              <span>393 RATINGS</span>
                              <span>231 REVIEWS</span>
                            </p>
                          </div>
                          <ul>
                            <li>
                              <span className="latoBold font18 lineHeight20">
                                4.1
                              </span>
                              <span className="font11 lineHeight20">
                                LOCATION
                              </span>
                            </li>
                            <li>
                              <span className="latoBold font18 lineHeight20">
                                4.3
                              </span>
                              <span className="font11 lineHeight20">
                                CLEANLINESS
                              </span>
                            </li>
                            <li>
                              <span className="latoBold font18 lineHeight20">
                                4.2
                              </span>
                              <span className="font11 lineHeight20">FOOD</span>
                            </li>
                          </ul>
                          <p
                            id="read_all_reviews"
                            className="pushRight makeFlex hrtlCenter latoBold linkText cursorPointer"
                          >
                            Read All Reviews
                            <div className="imgWrap">
                              <span className="overlaySprite backArrowBlue moreReviewsIcon"></span>
                            </div>
                          </p>
                        </div>
                      </div>
                      <div className="rvComp" id="review_section">
                        <ul>
                          <li id="review0">
                            <div className="makeFlex spaceBetween appendBottom12">
                              <div>
                                <h3 className="latoBlack font18 appendBottom5 vdarkGreenText lineHeight22">
                                  Nice stay with family
                                </h3>
                                <p className="latoBold font14 greyText">
                                  Shailendra Kumar Tiwari, Oct 04, 2023
                                </p>
                              </div>
                              <p className="ratng goodReview">5.0</p>
                            </div>
                            <p className="font14 lineHeight18">
                              <div>
                                The hotel room has two beds and two rooms in one
                                room m. All the amenities are provided including
                                haur dryer, geyser, coffe and tea sachets and
                                electric kettle. Room is very hygienic and
                                clean. Restraunt is good. Food is tasty.
                              </div>
                            </p>
                          </li>
                          <li id="review1">
                            <div className="makeFlex spaceBetween appendBottom12">
                              <div>
                                <h3 className="latoBlack font18 appendBottom5 vdarkGreenText lineHeight22">
                                  Average Stay
                                </h3>
                                <p className="latoBold font14 greyText">
                                  Ravinder Kumar, Oct 01, 2023
                                </p>
                              </div>
                              <p className="ratng avgReview">3.0</p>
                            </div>
                            <p className="font14 lineHeight18">
                              <div>
                                2. Bathroom not clean. Rooms aren't clean
                              </div>
                            </p>
                          </li>
                          <li id="review2">
                            <div className="makeFlex spaceBetween appendBottom12">
                              <div>
                                <h3 className="latoBlack font18 appendBottom5 vdarkGreenText lineHeight22">
                                  Extraordinary hotel
                                </h3>
                                <p className="latoBold font14 greyText">
                                  Deepak Navarathan, Sep 08, 2023
                                </p>
                              </div>
                              <p className="ratng goodReview">5.0</p>
                            </div>
                            <p className="font14 lineHeight18">
                              <div>
                                It was great place to stay in, balcony view is
                                awesome, staffs are generous, food is
                                extraordinary little expensive, good view from
                                balcony, room tarrif is reasonable, hotel is
                                located on the main road which makes as easier
                                for transportation, clean and tidy place,
                                overall it is a 10 out of 10 rating hotel
                              </div>
                            </p>
                          </li>
                          <li id="review3">
                            <div className="makeFlex spaceBetween appendBottom12">
                              <div>
                                <h3 className="latoBlack font18 appendBottom5 vdarkGreenText lineHeight22">
                                  Excellent Stay
                                </h3>
                                <p className="latoBold font14 greyText">
                                  deepak n, Sep 08, 2023
                                </p>
                              </div>
                              <p className="ratng goodReview">5.0</p>
                            </div>
                            <p className="font14 lineHeight18">
                              <div>
                                It was great place to stay in, balcony view is
                                awesome, staffs are generous, food is
                                extraordinary little expensive, good view from
                                balcony, room tarrif is reasonable, hotel is
                                located on the main road which makes as easier
                                for transportation, clean and tidy place,
                                overall it is a 10 out of 10 rating hotel
                              </div>
                            </p>
                          </li>
                          <li id="review4">
                            <div className="makeFlex spaceBetween appendBottom12">
                              <div>
                                <h3 className="latoBlack font18 appendBottom5 vdarkGreenText lineHeight22">
                                  The stay was pleasant and the facilities
                                  provided by hotel was much satisfactory
                                </h3>
                                <p className="latoBold font14 greyText">
                                  Rahul Sihag, Sep 04, 2023
                                </p>
                              </div>
                              <p className="ratng goodReview">5.0</p>
                            </div>
                            <p className="font14 lineHeight18">
                              <div>
                                I get to know about this hotel and when i
                                reached here i found it more attractive than
                                photos. Food was good and my family also
                                appreciated the food and staff. I’ll suggest
                                this hotel to my friends also.
                              </div>
                            </p>
                          </li>
                        </ul>
                        <div
                          id="intersectionPoint"
                          style={{ height: "20px" }}
                        ></div>
                      </div>
                    </div> */}
                  </div>
                </div>
                </>)}
              </>
            ) : (
              <>
              {openAccomodationDetails == 'ACCL' ?(
              <>
                <div className="sidePanelWrap _panelV2">
                  <div className="sidePanelTopSection">
                    <div className="makeFlex spaceBetween hrtlCenter appendBottom20 ">
                      <div className="">
                        <span className="font20 blackText latoBlack  false">
                         Add Accommodations
                        </span>
                      </div>
                      {/* <div className="searchBarWrapper">
                        <span className="overlaySprite searchIcon"></span>
                        <div className="flex">
                          <input
                            className="font11 searchInput "
                            placeholder="Search by Accommodations Name"
                            value=""
                          />
                        </div>
                      </div> */}
                    </div>
                    {/* <div className="hotelFliterOuter">
                      <div
                        id="hotelOverlayFilterWrapper"
                        className="filterWrapper"
                      >
                        <div
                          id="starRatingContainer_star_rating"
                          className="starRatingFilterWrapper"
                        >
                          <label className="labelName font11">
                            star rating
                          </label>
                          <div className="starRatingContainer">
                            <div className="boxContainer ">
                              <span className="ratingText font11">3</span>
                              <span className="overlaySprite starIcon"></span>
                            </div>
                            <div className="boxContainer ">
                              <span className="ratingText font11">4</span>
                              <span className="overlaySprite starIcon"></span>
                            </div>
                            <div className="boxContainer ">
                              <span className="ratingText font11">5</span>
                              <span className="overlaySprite starIcon"></span>
                            </div>
                          </div>
                        </div>
                        <span className="lineBar"></span>
                        <div className="multiSelectFilterWrapper">
                          <label className="labelName font11">Location</label>
                          <div
                            id="multiSelectContainer_Location"
                            className="multiSelectContainer "
                          >
                            <div className="multiSelectInput ">
                              <span className="selectedValues font11">Any</span>
                              <span className="dropdownIcon "></span>
                            </div>
                          </div>
                        </div>
                        <span className="lineBar"></span>
                        <div
                          id="starRatingContainer_user_rating"
                          className="userRatingFilterWrapper"
                        >
                          <label className="labelName font11">
                            user rating
                          </label>
                          <div className="userRatingContainer">
                            <div className="boxContainer ">
                              <span className="ratingText font11">
                                3 &amp; above
                              </span>
                              <span className="overlaySprite "></span>
                            </div>
                            <div className="boxContainer ">
                              <span className="ratingText font11">
                                4 &amp; above
                              </span>
                              <span className="overlaySprite "></span>
                            </div>
                            <div className="boxContainer ">
                              <span className="ratingText font11">
                                4.5 &amp; above
                              </span>
                              <span className="overlaySprite "></span>
                            </div>
                          </div>
                        </div>
                        <span className="lineBar"></span>
                        <div className="multiSelectFilterWrapper">
                          <label className="labelName font11">Hotel Type</label>
                          <div
                            id="multiSelectContainer_hotel_type"
                            className="multiSelectContainer "
                          >
                            <div className="multiSelectInput ">
                              <span className="selectedValues font11">Any</span>
                              <span className="dropdownIcon "></span>
                            </div>
                          </div>
                        </div>
                        <div
                          id="hotelOverlayMoreFilter"
                          className="moreFilterWrapper"
                        >
                          <label className="labelName font11">Filters</label>
                          <div className="moreFilterContainer">
                            <div className="iconContainer">
                              <span className="overlaySprite moreFilterIcon"></span>
                            </div>
                            <span className="moreFilterText font10">
                              more Filters
                            </span>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    <div className="sortByFilterWrapper">
                      <div className="filterMessage font12">
                        Showing {hotelList == null? " ":hotelList == "nohotel"? " ": hotelList.length}{" "}Accommodations in {AccommodationsData?.defaultZoneval}
                      </div>
                      {hotelList != null && hotelList != "nohotel" &&(
                      <div className="sortByFilterContainer makeFlex">
                        <span className="sortbyHeading font12">
                          &nbsp;|&nbsp;Sort by
                        </span>
                        
                        <div className="filterNameWrapper">
                          <span className="filterName font12" onClick={showSorting}>
                            &nbsp;{sortingSelect}
                          </span>
                          <span className="dropdownIcon "></span>
                        </div>
                         
                          {hotelList != null && hotelList != "nohotel" && sorting && (
                            <ul class="dropdownList">
                              {SortArr.map((item, index) => (
                                <li
                                  className={sortingSelect == item?.name
                                      ? "optionNameConatiner font12 selected"
                                      : "optionNameConatiner font12"
                                  }
                                  key={index}
                                  onClick={() => handleSortingChange(item)}
                                >
                                <span class="optionValue">
                                  {item.name}
                                  </span>
                                </li>
                              ))}
                            </ul>
                            
                          )}

                        
                         
                      
                        
                      </div>
                      )}
                    </div>
                  </div>
                  <div
                    id="hotelOverlayListing"
                    className="hotelBodyContainer showBadge"
                  >
                    <div className="sidePanelBody">
                      {/* <div
                        id="hotelOverlayCardWrapper"
                        className="hotelCardWrapper selected "
                        data-testid="hotel-listing"
                      >
                        <div className="hotelPanel_leftContainer">
                          <div className="imageWrapper">
                            <div className="imageLoaderContainer ">
                              <img
                                className=" active "
                                width="208px"
                                src="https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/201904031849475047-c9068ac6549411eaa2ce0242ac110007.jpg?&amp;downsize=900:675&amp;crop=900:675;56,0&amp;output-format=jpg"
                              />
                            </div>
                            <div className="selectedBadgeWrapper ">
                              <span className="badgeBar"></span>
                              <div className="selectedBadgeContainer">
                                <div className="tickContainer">
                                  <div className="tick"></div>
                                </div>
                                <span
                                  className="selectedBadgeText font10"
                                  data-testid="selected-room"
                                >
                                  Selected Hotel
                                </span>
                              </div>
                            </div>
                            <div className="ratingBadgeContainer  goodRating">
                              <p className="selectedBadgeText font12">
                                4.4<span className="font10">/5</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="hotelPanel_rightContainer">
                          <div className="flex">
                            <p
                              className="viewDetails linkText cursorPointer"
                             onClick={() => detailsPageData() }
                            >
                              VIEW DETAILS
                            </p>
                          </div>
                          <div className="flex hotelTitle">
                            <h3 className="hotelHeading">
                            Raffles Seychelles
                           
                              <span className="hotelRating rating_blank">
                                <span
                                  className="hotelRating rating_fill "
                                  style={{ width: "36px" }}
                                ></span>
                              </span>
                            </h3>
                           
                          </div>
                          <div className="location font11">Anse Takamaka, Baie Ste Anne, Seychelles</div>
                          <div className="latoBold font11 greyText lineHeight14"></div>
                          <div className="flex badge"></div>
                          <div className="calendarWrapper">
                            <span className="overlaySprite calendarIcon"></span>
                            <span className="bookingDate font10">
                              Fri, 1 Dec 2023 - Mon, 3 Dec 2023
                            </span>
                          </div>
                          <div className="hotelPanel_rightContainerFooter">
                            <div className="hotelPanel_rightContainerFooterWrapper">
                              <div className="flex">
                                <span className="includes font11">
                                  Includes
                                </span>
                                <span className="includesDetails font11">
                                  Breakfast
                                </span>
                              </div>
                              <div className="flex roomTypeWrapper">
                                <span className="roomType font11">
                                  Room Type
                                </span>
                                <span className="roomTypeDetails font11">
                                  <span>Deluxe Room with Sofa Cum Bed</span>
                                </span>
                                <a className="changeRoom font10">Change Room</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                        {hotelList === null ? (
                    <>
                       <ListingSkeleton/>
                        <ListingSkeleton/>
                        <ListingSkeleton/> 
                    </>
                  ) : hotelList == "nohotel" ? (
                   <>
                     <div  id="hotelOverlayCardWrapper"
                        className="hotelCardWrapper ">
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-lg-12">
                                <div className="d-flax justifi-content-center">
                                    <div className="images-part">
                                    <img src={"images/noHotel.png"} style={{ margin: "0 auto" }}/>
                                    </div>
                                    <div className="soldoutcontent">
                                        <h3>We're sorry</h3>
                                        <p>This accommodation is not available at this moment. Please try again later or look for an alternative accommodation.</p>

                                        {/* <Link to="/home">
                                        <span className="hsw_searchButtonList">Search again</span>
                                        </Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                   </>
                  ) : (
                    <>
                     {hotelList.map((item, key) => (
                      <div
                        id="hotelOverlayCardWrapper"
                        className="hotelCardWrapper  "
                        data-testid="hotel-listing"
                      >
                        <div className="hotelPanel_leftContainer">
                          <div className="imageWrapper">
                            <div className="imageLoaderContainer ">
                              {/* <img
                                className=" active "
                                width="208px"
                                src="https://r1imghtlak.mmtcdn.com/cf674b72708311ed9ae40a58a9feac02.png?&amp;downsize=900:675&amp;output-format=jpg"
                              /> */}
                                {item?.details?.property_source == 1 ?(<>{item?.property_gallery != null ? (
                                item?.property_gallery.slice(0, 1)
                                  .map((itemimg, key1) => (
                                    <LazyLoadImage
                                      src={
                                        ImageChanger == null ? itemimg?.image : ImageChanger
                                      }
                                      className="listing-carousel-slide active "
                                      placeholderSrc={
                                        process.env.PUBLIC_URL +
                                        "images/placeholder.png"
                                      }
                                      key={key1}
                                    />
                                  ))
                              ) : (
                                <LazyLoadImage src={"images/placeholder.png"} />
                              )}</>):(<>{item?.property_gallery!= null ? (item?.property_gallery.slice(0, 1)
                                  .map((itemimg, key1) => (
                                    <LazyLoadImage
                                    src={
                                      ImageChanger == null
                                        ? SupplierUrl+"/uploads/property_gallery_main/"+itemimg?.image
                                        : ImageChanger
                                    }
                                      className="listing-carousel-slide active"
                                    />
                                  ))
                              ) : (
                                <LazyLoadImage src={"images/placeholder.png"} />
                              )}</>)
                              }
                            </div>
                            {/* <div className="ratingBadgeContainer  goodRating">
                              <p className="selectedBadgeText font12">
                             {item?.details?.star_category_id &&(<>{item?.details?.star_category_id == 1}<span className="font10">/5</span></>)} 
                              </p>
                            </div> */}
                          </div>
                        </div>
                        <div className="hotelPanel_rightContainer">
                          <div className="flex">
                            <p
                              className="viewDetails linkText cursorPointer"
                             onClick={() => detailsPageData(item?.details?.id) }
                            >
                              VIEW DETAILS
                            </p>
                          </div>
                          <div className="flex hotelTitle">
                            <h3 className="hotelHeading">
                            {item?.details?.property_name}
                              <span className="hotelRating rating_blank">
                                <span
                                  className="hotelRating rating_fill "
                                  style={{ width: "48px" }}
                                ></span>
                              </span>
                            </h3>
                          </div>
                          <div className="location font11"> {item?.details?.address_line_1}</div>
                          <div className="latoBold font11 greyText lineHeight14">
                          {item?.details?.star_category_id &&(item?.details?.star_category_id == 1?'1 star':item?.details?.star_category_id == 2?'2 star':item?.details?.star_category_id == 3?'3 star':item?.details?.star_category_id == 4?'4 star':item?.details?.star_category_id == 5?'5 star':item?.details?.star_category_id == 6?'Luxury Villa':item?.details?.star_category_id == 7?'Self Catering':item?.details?.star_category_id == 8?'Small Hotel':item?.details?.star_category_id == 9?'Guest House':"")}
                          </div>
                          <div className="flex badge">
                            <div className="additionalCharge font20">
                              {/* <span>€ 206</span> */}
                             
                              <p className="appendBottom5"><span className="font-weight-bold from-price-text">Per Night From </span></p>
                              {item?.details?.property_source == 1 ? (
                                  <>
                                    {item?.ejuniper?.HotelOfferAmount == "" ? (
                                      <p
                                        className="latoBlack font16 blackText appendBottom5"
                                        id="hlistpg_hotel_shown_price"
                                      >
                                      <span>€</span>
                                        {(
                                          Math.round(item?.ejuniper?.NewAmount * 100) / 100
                                        ).toFixed(2)}
                                      </p>
                                    ) : (
                                      <>
                                        {" "}
                                        {item?.ejuniper?.PercentageAm == 0 ? (
                                          <>
                                          {/* <p><span className="font-weight-bold text-lowercase from-price-text">From </span></p> */}
                                          <p
                                            className="latoBlack font16 blackText appendBottom5"
                                            id="hlistpg_hotel_shown_price"
                                          >
                                          <span>€</span>
                                            {(
                                              Math.round(item?.ejuniper?.Amount * 100) / 100
                                            ).toFixed(2)}
                                          </p>
                                          </>
                                        ) : (
                                          <>
                                            {" "}
                                          
                                            
                                            {/* <p><span className="font-weight-bold text-lowercase from-price-text"> </span></p> */}
                                            <div className="listingPrice">
                                            <p
                                              className="grayText font16 lineThrough appendBottom5 appendRight5"
                                              id="hlistpg_hotel_cut_price"
                                            >
                                            <span>€</span>
                                              {(
                                                Math.round(item?.ejuniper?.Amount * 100) / 100
                                              ).toFixed(2)}
                                            </p>
                                            
                                            <p
                                              className="latoBlack font16 blackText appendBottom5"
                                              id="hlistpg_hotel_shown_price"
                                            >
                                            <span>€</span>
                                              {(
                                                Math.round(item?.ejuniper?.HotelOfferAmount * 100) /
                                                100
                                              ).toFixed(2)}
                                            </p>
                                            </div>
                                            <p class="makeFlex hrtlCenter right appendBottom10 directionRtl">
                                              <span class="redText font12">
                                                <span>Save </span>
                                                <span
                                                  class="latoBold"
                                                  id="hlistpg_hotel_saved_price"
                                                >
                                                <span>€</span>
                                                  {(
                                                    Math.round(
                                                      item?.ejuniper?.HotelOfferAmNew * 100
                                                    ) / 100
                                                  ).toFixed(2)}
                                                </span>
                                              </span>
                                              <span class="spriteNew discountIcon relative appendLeft5">
                                                <span
                                                  class="latoBold font11 whiteText discountText"
                                                  id="hlistpg_hotel_saved_price_percentage"
                                                  style={{
                                                    lineHeight: "15px",
                                                    paddingRight: "5px",
                                                  }}
                                                >
                                                  {item?.ejuniper?.PercentageAm}%
                                                </span>
                                              </span>
                                            </p>
                                           
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item?.details?.property_source == 2 ? (
                                      <>
                                        {item?.hotellink == "" ? (
                                          <></>
                                        ) : (
                                          <>
                                            {getAmountHotelLink(item?.hotellink)}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {item?.hs_portal == ""|| item?.hs_portal == undefined ? (
                                          <></>
                                        ) : (
                                          <>{getAmountHsPortal(item?.hs_portal)}</>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              {/* <span className="perPerson font12">
                                Per Night From
                              </span> */}
                            </div>
                          </div>
                          {/* <div className="calendarWrapper">
                            <span className="overlaySprite calendarIcon"></span>
                            <span className="bookingDate font10">
                              Fri, 1 Dec 2023 - Mon, 4 Dec 2023
                            </span>
                          </div> */}
                          
                          {/* <div className="hotelPanel_rightContainerFooter">
                            <div className="hotelPanel_rightContainerFooterWrapper">
                              <div className="flex">
                                <span className="includes font11">
                                  Includes
                                </span>
                                <span className="includesDetails font11">
                                  Breakfast
                                </span>
                              </div>
                              <div className="flex roomTypeWrapper">
                                <span className="roomType font11">
                                  Room Type
                                </span>
                                <span className="roomTypeDetails font11">
                                  <span>The SUAVE - Holiday Selection</span>
                                </span>
                                <a className="changeRoom font10">Change Room</a>
                              </div>
                            </div>
                            <span className="primaryBtn fill selectBtn">
                              Select
                            </span>
                          </div> */}
                        
                        </div>
                        {/* {item?.details?.property_source == 1 && item?.ejuniper.HotelOfferName != "" ? (
                      <div class="title__placeHolder">
                          <div class="persuasion ">
                            <div class="persuasion__item pc__cashbackDeal">
                              <span class="sprite infoIconGreen"></span>
                              <span>Special Offer - {item?.ejuniper.HotelOfferName}</span>
                            </div>
                          </div>
                        </div>):(<></>)} */}
                      </div>
                      ))}
                      </>
                          )}
                      
                     
                    </div>
                  </div>
                </div>
              </>
            ):(<>
            {openAccomodationDetails == 'ACCF'?(
            <>
            <div className="sidePanelWrap viewDetails_panelV2">
      <div className="sidePanelTopSection">
        <div className="makeFlex spaceBetween hrtlCenter appendBottom20 ">
          <div className="viewDetailsHeading">
            <span
              id="hotelBackArrow"
              className="overlaySprite backArrowBlue backIcon appendTop3"
              onClick={() => backAccomodationDetails() }  ></span>
            <span className="font20 blackText latoBlack viewDetailText false">
              Go Back to {HotelDetails?.property_name}
            </span>
          </div>
        </div>
      </div>
      <div className="paddingLR15 viewGalleryWrapper">
        <div className="htFacilities">
          <div className="makeFlex hrtlCenter spaceBetween appendBottom15">
            <h4>Property facilities</h4>
            <p className="openFacilities latoBold font12 facilityTag">
              All Facilities
            </p>
          </div>
          {HotelServices.map((item, key) =>
                    item == null ? (
                      <></>
                    ) : (
                      item?.head_name.map((item1, key1) => (
                        <div className="KuomZ">
                          <p className="latoBold font12 blackText capText appendBottom15">
                            {item1?.head_name}
                          </p>
                          <ul className="htFacilitiesList">
                          {item1?.data.map((dat, key2) => (
                              <li>
                                <p>
                                  {" "}
                                  <span className="amenitiesSpriteOverlay icon24 amenityIconDefault appendRight5 htFacilitySpan"></span>
                                  <p>{dat}</p>
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))
                    )
                  )}
        </div>
        <div>
          <div className="htGallery">
            <ul>
            
            {HotelGallery.length > 0 &&(Object.values(HotelGallery).map((imagedata, key2) => (
              <li>
                <div className="imgWrap">
                  <div
                    className="imageLoaderContainer "
                    style={{ width: "720px", height: "414px" }}
                  >
                    <img
                      className=" active "
                      width="720"
                      height="414"
                      src={HotelGallery[key2]}
                      style={{ borderRadius: "4px" }}
                    />
                  </div>
                </div>
              </li>
               )))}
            </ul>
          </div>
        </div>
      </div>
    </div>
            </>):(<></>)}
           
            </>)}</>)}
            
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}
export default AccomodationListingPopup;
